import React from 'react'

function Jewellery() {
  return (
    <div>Jewellery</div>
  )
}

export default Jewellery